/* Nexum „Любими“ — запазване, възстановяване и чекмедже.

   Разделение на труда:
   nexum-interactions.js ПРЕВКЛЮЧВА сърцето по картата (клас fx-on +
   aria-pressed). Този файл НЕ дублира превключването — закача се на
   window, а не на document, така че кликът стига до него СЛЕД
   document-слушателя на interactions.js, независимо кой скрипт се е
   заредил пръв. Тогава чете какво е станало с класа и записва.

   Данните живеят в localStorage под of4_wish: масив от обекти с
   handle, вариант, заглавие, цена, снимка и адрес — достатъчно,
   за да се нарисува чекмеджето без нито една заявка към магазина.
   Най-новото е отпред; при преливане падат най-старите отзад.

   Добавянето в количката минава през наш собствен fetch към
   /cart/add.js. За отварянето на количката-чекмедже ползваме
   публичното window.NexumDrawer (open/refresh) от nexum-drawer.js. */

(function () {
  'use strict';

  var KEY = 'of4_wish';
  var MAX = 60;
  var LOCK = 'nav-lock';
  var HIDE_MS = 300;

  var T = {
    add: 'Добави в любими',
    rm: 'Премахни от любими',
    fail: 'Продуктът не може да бъде добавен в количката.'
  };

  /* ================= хранилище ================= */

  var mem = null;

  function read() {
    if (mem) return mem;
    var raw = null;
    try {
      raw = window.localStorage.getItem(KEY);
    } catch (e) {
      raw = null;
    }
    var list = [];
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Object.prototype.toString.call(parsed) === '[object Array]') {
          for (var i = 0; i < parsed.length; i++) {
            var it = parsed[i];
            if (it && typeof it === 'object' && it.h) list.push(it);
          }
        }
      } catch (e) {
        list = [];
      }
    }
    if (list.length > MAX) list.length = MAX;
    mem = list;
    return mem;
  }

  function save(list) {
    mem = list;
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* частен режим или пълна квота — паметта в таба продължава да работи */
    }
  }

  function indexOfHandle(list, h) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].h === h) return i;
    }
    return -1;
  }

  function add(item) {
    var list = read().slice();
    var i = indexOfHandle(list, item.h);
    if (i !== -1) list.splice(i, 1);
    list.unshift(item);
    if (list.length > MAX) list.length = MAX;
    save(list);
  }

  function remove(h) {
    var list = read().slice();
    var i = indexOfHandle(list, h);
    if (i === -1) return;
    list.splice(i, 1);
    save(list);
  }

  /* ================= помощни ================= */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      if (c === '&') return '&amp;';
      if (c === '<') return '&lt;';
      if (c === '>') return '&gt;';
      if (c === '"') return '&quot;';
      return '&#39;';
    });
  }

  /* money филтърът може да върне &euro; вместо знака; атрибутът минава през
     escape в Liquid, така че тук връщаме текста в четим вид точно веднъж */
  var deco = null;
  function decode(s) {
    if (!s || s.indexOf('&') === -1) return s || '';
    if (!deco) deco = document.createElement('textarea');
    deco.innerHTML = s;
    return deco.value;
  }

  function all(sel, root) {
    return [].slice.call((root || document).querySelectorAll(sel));
  }

  /* Картата вече носи заглавието, цената, снимката и адреса във видимия си
     HTML. Дотук ги ДУБЛИРАХМЕ в data-wish-* атрибути на сърцето — при 138
     карти на началната това бяха 87 KB HTML само за да повторим нещо, което
     и без това е на екрана. Сега ги четем от самата карта.

     Атрибутът пак бие DOM-а, когато го има: карти извън nexum-card-product
     (бърз преглед, външни секции) може да подават пълния комплект и не
     искаме да ги чупим заради тази промяна. Затова редът е атрибут → DOM. */

  function cardOf(b) {
    return (b.closest && b.closest('[data-handle]')) || null;
  }

  /* събира само ASCII празнотата — тясната шпация в „6,08 €“ е част от
     цената и трябва да оцелее, за да изглежда чекмеджето като картата */
  function txt(root, sel) {
    if (!root) return '';
    var el = root.querySelector(sel);
    return el ? (el.textContent || '').replace(/[ \t\r\n]+/g, ' ').trim() : '';
  }

  function attr(b, name) {
    var v = b.getAttribute('data-wish-' + name);
    return v == null ? '' : v;
  }

  function handleOf(b) {
    var h = attr(b, 'handle');
    if (h) return h;
    var card = cardOf(b);
    return card ? card.getAttribute('data-handle') || '' : '';
  }

  function fromButton(b) {
    var h = handleOf(b);
    if (!h) return null;

    var card = cardOf(b);
    var link = card ? card.querySelector('a.card-title, .card-media a[href]') : null;
    var pic = card ? card.querySelector('.card-media img') : null;

    var im = attr(b, 'img');
    if (!im && pic) {
      /* картата тегли 600 px, чекмеджето рисува 74 px — сглобяваме същия
         адрес, който Liquid слагаше в data-wish-img, тоест width=200 */
      im = (pic.getAttribute('src') || '').replace(/([?&]width=)\d+/, '$1200');
    }

    var u = attr(b, 'url');
    if (!u && link) u = link.getAttribute('href') || '';

    return {
      h: h,
      id: attr(b, 'id'),
      t: decode(attr(b, 'title')) || txt(card, '.card-title'),
      p: decode(attr(b, 'price')) || txt(card, '.card-now .money'),
      im: im,
      u: u,
      m: attr(b, 'multi') === '1' ? 1 : 0,
      a: attr(b, 'avail') === '0' ? 0 : 1
    };
  }

  /* ================= рисуване на състоянието ================= */

  function paint() {
    var list = read();
    var map = {};
    for (var i = 0; i < list.length; i++) map[list[i].h] = 1;

    var btns = all('.card-wish');
    for (var j = 0; j < btns.length; j++) {
      var b = btns[j];
      var bh = handleOf(b);
      if (!bh) continue;
      var on = map[bh] === 1;
      if (b.classList.contains('fx-on') !== on) b.classList.toggle('fx-on', on);
      var pressed = on ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== pressed) b.setAttribute('aria-pressed', pressed);
      var label = on ? T.rm : T.add;
      if (b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
    }

    var n = list.length;
    var badges = all('[data-nxw-count]');
    for (var k = 0; k < badges.length; k++) {
      badges[k].textContent = n > 99 ? '99+' : String(n);
      if (n > 0) badges[k].removeAttribute('hidden');
      else badges[k].setAttribute('hidden', '');
    }
    var openers = all('[data-nxw-open]');
    for (var m = 0; m < openers.length; m++) openers[m].classList.toggle('is-on', n > 0);
  }

  /* ================= чекмеджето ================= */

  function box() {
    return document.getElementById('nxw-drawer');
  }

  function isOpen() {
    var el = box();
    return !!el && !el.hidden;
  }

  function err(msg) {
    var el = box();
    if (!el) return;
    var e = el.querySelector('[data-nxw-err]');
    if (e) e.textContent = msg || '';
  }

  function rowHTML(it) {
    var url = it.u || '/products/' + it.h;
    /* Без снимка не рендираме и рамката ѝ: празният <a> така или иначе
       пада под `a:empty { display: none }` от base.css на Dawn, а
       нахалост оставена дупка в решетката изглежда като счупено. */
    var img = it.im
      ? '<a class="nxw-img" href="' +
        esc(url) +
        '" tabindex="-1" aria-hidden="true"><img src="' +
        esc(it.im) +
        '" alt="" width="74" height="74" loading="lazy" decoding="async"></a>'
      : '';
    var cta;
    if (!it.a) {
      cta = '<span class="nxw-gone">Очаква доставка</span>';
    } else if (it.m || !it.id) {
      cta = '<a class="nxw-add" href="' + esc(url) + '">Избери вариант</a>';
    } else {
      cta = '<button type="button" class="nxw-add" data-nxw-add="' + esc(it.id) + '">Добави в количката</button>';
    }
    return (
      '<li class="nxw-row" data-nxw-key="' + esc(it.h) + '">' +
      img +
      '<div class="nxw-info">' +
      '<a class="nxw-t" href="' + esc(url) + '">' + esc(it.t) + '</a>' +
      (it.p ? '<div class="nxw-p">' + esc(it.p) + '</div>' : '') +
      '<div class="nxw-acts">' +
      cta +
      '<button type="button" class="nxw-rm" data-nxw-rm aria-label="Премахни „' +
      esc(it.t) +
      '“ от любими">Премахни</button>' +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  function render() {
    var el = box();
    if (!el) return;
    var lines = el.querySelector('[data-nxw-lines]');
    var empty = el.querySelector('[data-nxw-empty]');
    var foot = el.querySelector('[data-nxw-foot]');
    if (!lines || !empty) return;

    var list = read();
    if (!list.length) {
      lines.innerHTML = '';
      lines.setAttribute('hidden', '');
      empty.removeAttribute('hidden');
      if (foot) foot.setAttribute('hidden', '');
      return;
    }
    var html = '';
    for (var i = 0; i < list.length; i++) html += rowHTML(list[i]);
    lines.innerHTML = html;
    lines.removeAttribute('hidden');
    empty.setAttribute('hidden', '');
    if (foot) foot.removeAttribute('hidden');
  }

  function focusables() {
    var el = box();
    if (!el) return [];
    return all('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', el).filter(
      function (n) {
        return n.offsetParent !== null;
      }
    );
  }

  var lastFocus = null;
  var hideT = null;

  function openDrawer(from) {
    var el = box();
    if (!el || !el.hidden) return;
    err('');
    render();
    clearTimeout(hideT);
    lastFocus = from || document.activeElement;
    el.hidden = false;
    void el.offsetHeight;
    el.classList.add('on');
    document.documentElement.classList.add(LOCK);
    var openers = all('[data-nxw-open]');
    for (var i = 0; i < openers.length; i++) openers[i].setAttribute('aria-expanded', 'true');
    var f = focusables();
    (f[0] || el.querySelector('.nxw-inner') || el).focus();
  }

  function closeDrawer() {
    var el = box();
    if (!el || el.hidden) return;
    el.classList.remove('on');
    document.documentElement.classList.remove(LOCK);
    var openers = all('[data-nxw-open]');
    for (var i = 0; i < openers.length; i++) openers[i].setAttribute('aria-expanded', 'false');
    hideT = setTimeout(function () {
      el.hidden = true;
    }, HIDE_MS);
    var back = lastFocus;
    lastFocus = null;
    if (back && back.isConnected && back.focus) back.focus();
  }

  /* ================= количка ================= */

  function addUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }

  /* Отговорът носи пресния cart-icon-bubble; хедърът си пази нашата икона
     сам — неговият MutationObserver я връща след смяната на innerHTML. */
  function paintBubble(sections) {
    if (!sections) return;
    var html = sections['cart-icon-bubble'];
    var host = document.getElementById('cart-icon-bubble');
    if (!html || !host || !window.DOMParser) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sec = doc.querySelector('.shopify-section');
      if (sec) host.innerHTML = sec.innerHTML;
    } catch (e) {
      /* по-добре стар брояч, отколкото счупен хедър */
    }
  }

  function addToCart(btn, id) {
    if (!id || btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    err('');

    var payload = { items: [{ id: Number(id), quantity: 1 }] };
    if (document.getElementById('cart-icon-bubble')) {
      payload.sections = 'cart-icon-bubble';
      payload.sections_url = window.location.pathname;
    }

    fetch(addUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (d) {
          return { ok: r.ok, d: d };
        });
      })
      .then(function (res) {
        if (!res.ok || (res.d && res.d.status && res.d.status !== 200)) {
          throw new Error((res.d && (res.d.description || res.d.message)) || T.fail);
        }
        paintBubble(res.d && res.d.sections);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'nexum-wishlist',
            productVariantId: String(id),
            cartData: res.d
          });
        }
        var d = window.NexumDrawer;
        return d && d.refresh ? d.refresh() : null;
      })
      .then(function () {
        btn.removeAttribute('aria-disabled');
        closeDrawer();
        var d = window.NexumDrawer;
        if (d && d.open) d.open();
        else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function (e) {
        btn.removeAttribute('aria-disabled');
        err(e && e.message ? e.message : T.fail);
      });
  }

  /* ================= събития ================= */

  /* window, не document: така сме СЛЕД document-слушателя на
     nexum-interactions.js, който вече е сменил fx-on */
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var wish = t.closest('.card-wish');
    if (wish) {
      var it = fromButton(wish);
      if (!it) return;
      if (wish.classList.contains('fx-on')) add(it);
      else remove(it.h);
      paint();
      if (isOpen()) render();
      return;
    }

    var opener = t.closest('[data-nxw-open]');
    if (opener) {
      e.preventDefault();
      if (isOpen()) closeDrawer();
      else openDrawer(opener);
      return;
    }

    if (!isOpen()) return;

    if (t.closest('[data-nxw-close]') || t.closest('.nxw-ov')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var rm = t.closest('[data-nxw-rm]');
    if (rm) {
      e.preventDefault();
      var row = rm.closest('.nxw-row');
      if (row) {
        remove(row.getAttribute('data-nxw-key'));
        paint();
        render();
      }
      return;
    }

    var addBtn = t.closest('[data-nxw-add]');
    if (addBtn) {
      e.preventDefault();
      addToCart(addBtn, addBtn.getAttribute('data-nxw-add'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') {
      e.stopPropagation();
      closeDrawer();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* друг таб е пипнал списъка */
  window.addEventListener('storage', function (e) {
    if (e.key && e.key !== KEY) return;
    mem = null;
    paint();
    if (isOpen()) render();
  });

  /* ================= старт ================= */

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      paint();
    }, 60);
  }

  function boot() {
    paint();
    /* картите се дорисуват след fetch (филтри, „още продукти“, бърз преглед) */
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('load', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.NexumWishlist = {
    open: function () {
      openDrawer(null);
    },
    close: closeDrawer,
    count: function () {
      return read().length;
    }
  };
})();
